import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Login from './components/Login';
import Painel from './components/Painel';
import CorridaRegistrada from './components/CorridaRegistrada';
import CorridasAndamento from './components/CorridasAndamento';
import CorridasAgendadas from './components/CorridasAgendadas';
import CorridasConcluidas from './components/CorridasConcluidas';
import CorridasCanceladas from './components/CorridasCanceladas';
import DetalhesCorrida from './components/DetalhesCorrida';
import Faturas from './components/Faturas';
import CadastroAutorizados from './components/CadastroAutorizados';
import NovoAutorizado from './components/NovoAutorizado';
import EditarAutorizado from './components/EditarAutorizado';
import VoucherAvulso from './components/VoucherAvulso';
import NovoVoucherAvulso from './components/NovoVoucherAvulso';
import CadastroDepartamento from './components/CadastroDepartamento';
import NovoDepartamento from './components/NovoDepartamento';
import EditarVoucherAvulso from './components/EditarVoucherAvulso';
import VouchersAFaturar from './components/VouchersAFaturar';
import VouchersFaturados from './components/VouchersFaturados';
import VouchersCancelados from './components/VouchersCancelados';
import VouchersNaoAutorizados from './components/VouchersNaoAutorizados';
//import VouchersContestados from './components/VouchersContestados';
import RedeCredenciada from './components/RedeCredenciada';
import MinhaConta from './components/MinhaConta';
import Acompanhamento from './components/Acompanhamento';
import ResetSenha from './components/ResetSenha';
import Empregados from './components/Empregados';
import CentroDeCusto from './components/CentroDeCusto';
import MeusFavoritos from './components/meusFavoritos';
import Precadastro from './components/Precadastro';
import Solicitar from './components/Solicitar.js';
import { Helmet } from "react-helmet";

//Fontes
import './fonts/Fontes.css'
import './fonts/FontAwesome.ttf'
import './fonts/AntDesign.ttf'
import './fonts/Entypo.ttf'
import './fonts/EvilIcons.ttf'
import './fonts/Feather.ttf'
import './fonts/Fontisto.ttf'
import './fonts/Foundation.ttf'
import './fonts/Ionicons.ttf'
import './fonts/MaterialCommunityIcons.ttf'
import './fonts/MaterialIcons.ttf'
import './fonts/Octicons.ttf'
import './fonts/SimpleLineIcons.ttf'
import './fonts/Zocial.ttf'
//Fontes


import './App.css'
import './assets/global/plugins/font-awesome/css/font-awesome.css'
import './assets/global/plugins/simple-line-icons/simple-line-icons.css'
import './assets/global/plugins/bootstrap/css/bootstrap.css'
import './assets/global/plugins/bootstrap-switch/css/bootstrap-switch.css'
import './assets/global/plugins/select2/css/select2.css'
import './assets/global/css/components.css'
import './assets/global/css/plugins.css'
import './assets/global/plugins/bootstrap-select/css/bootstrap-select.css'
import './assets/global/css/todo.css'
import './assets/global/css/star-rating.css'
import './assets/global/css/conta.css'
import './assets/global/css/guillotine.css'
import './assets/pages/css/invoice.css'
import './assets/pages/css/profile.css'
import './assets/layouts/layout3/css/layout.css'
import './assets/layouts/layout3/css/themes/default.css'
import './assets/layouts/layout3/css/themes/blue-hoki.css'
import './assets/layouts/layout3/css/custom.css'

import { Modal } from 'react-bootstrap'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import WS from './services/webservice'
import _ from 'lodash'

var jwtDecode = require('jwt-decode')







class AppOld extends Component {
  constructor(props) {
    super(props)

    this.state = {
      appshowNovaSenha: false,
      userData: [],
      userDatausernome: null,
      userDatauseremail: null,
      isAuthenticated: false,
      selected: {},
      dataCentrais: [],
      dataEmpresas: [],
      caridades: [],
      caridadefunc: 0,
      caridadeescolhida: {},
      empresa: {
        nome: '',
        cnpj: '',
        nomefantasia: '',
        endereco: '',
        telefone: ''
      },
      centralcores: {
        id:3,
        razaosocial:"GO Soluçoes",
        aplicativocor:{terceary: "#ffffff", background: "#000000", foreground: "#ffffff"},
        appicon:"data:image/jpeg;base64,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"},
      perfil: '',
      user: [],
      func: [],
      showCentral: false,
      showEmpresa: false,
      showcaridade: false,
      showUser: 'none',
      openClose: {
        painel: {
          nome: 'Painel',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        gestao: {
          nome: 'Gestao',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        corridas: {
          nome: 'Corridas',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        faturas: {
          nome: 'Faturas',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        relatorios: {
          nome: 'Relatorios',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        empregados: {
          nome: 'Empregados',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        centroDeCusto: {
          nome: 'CentroDeCusto',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        voucherAvulso: {
          nome: 'VoucherAvulso:',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        cadastroDepartamento: {
          nome: 'CadastroDepartamento:',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        redeCredenciada: {
          nome: 'RedeCredenciada',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        vouchersAFaturar: {
          nome: 'VouchersAFaturar',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        solicitarCorrida: {
          nome: 'SolicitarCorrida',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        corridasAndamento: {
          nome: 'CorridasAndamento',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        corridasAgendadas: {
          nome: 'CorridasAgendadas',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        vouchersFaturados: {
          nome: 'VouchersFaturados',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        corridasConcluidas: {
          nome: 'CorridasConcluidas',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        corridasCanceladas: {
          nome: 'CorridasCanceladas',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        vouchersCancelados: {
          nome: 'VouchersCancelados',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        cadastroAutorizados: {
          nome: 'CadastroAutorizados',
          class: 'menu-dropdown classic-menu-dropdown  '
        },
        //vouchersContestados: { nome: 'VouchersContestados', class: "menu-dropdown classic-menu-dropdown  ", },
        vouchersNaoAutorizado: {
          nome: 'VouchersNaoAutorizado',
          class: 'menu-dropdown classic-menu-dropdown  '
        }
      }
    }

    this.webservice = new WS()

    this.setOpen = this.setOpen.bind(this);
    this.modalHide = this.modalHide.bind(this);
    this.modalHidenovasenha = this.modalHidenovasenha.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.modalHideEmpresa = this.modalHideEmpresa.bind(this);
    this.getHexColor = this.getHexColor.bind(this);
    this.shadeHexColor = this.shadeHexColor.bind(this);
    this.toggleRowEmpresa = this.toggleRowEmpresa.bind(this);
    this.modalhidecaridae = this.modalhidecaridae.bind(this);
    this.modalShowcaridade = this.modalShowcaridade.bind(this);
    this.verificaCaridade = this.verificaCaridade.bind(this);
    this.SetaCaridades = this.SetaCaridades.bind(this);
    this.getDadosCentralCores = this.getDadosCentralCores.bind(this);
  }

  async getDadosCentralCores() {
    let central = await this.webservice.getCentralInfosCores()
    if (!!central.id) {this.setState({centralcores: central})}
  }

  componentDidMount() {
    this.getDadosCentralCores();
    //let root = document.documentElement;
    //root.style.setProperty('--barra-menu', '#000000')
    //console.log("O COMEÇO", root)
  }
  async modalhidecaridae() {
    this.setState({ showcaridade: false })
  }
  async modalShowcaridade() {
    this.setState({ showcaridade: true })
  }
  async SetaCaridades(id) {
    this.modalhidecaridae()
    this.webservice.saveFuncCaridade(this.state.func.id, id).then(() => {
      this.toggleRowEmpresa(this.state.empresa)
    })
  }
  async verificaCaridade() {
    console.log('verificaCaridade', [
      this.state.caridadefunc,
      this.state.caridades
    ])
    if (this.state.caridades && this.state.caridades.length > 0) {
      if (this.state.caridadefunc === null) {
        this.modalShowcaridade()
      } else {
        let escolhida = this.state.caridades.find(
          (a) => a.id === this.state.caridadefunc
        )
        if (escolhida) {
          this.setState({ caridadeescolhida: escolhida })
        }
      }
    }
  }
  async loginUser(user) {
    let data
    if (user.token) {
      data = jwtDecode(user.token)
      this.webservice.setCookie('portal-token', user.token, 1)
    } else {
      data = jwtDecode(user)
      this.webservice.setCookie('portal-token', user, 1)
    }
    let empresafav = this.webservice.getCookie('empresa-preferida')

    if (data.empresas.length > 0) {
      console.log('executando coockie')
      console.log('empresafav coockie', empresafav)
      if (!empresafav) {
        empresafav = data.empresas[0]
      }
      console.log('empresafav data.empresas', data.empresas)
      console.log('empresafav check fav', data.empresas.includes(Number(empresafav)))
      if (!data.empresas.includes(Number(empresafav))) {
        empresafav = data.empresas[0]
      }
      console.log('empresafav novofav', empresafav)
      //
      await this.webservice.setCookie('empresa-id', empresafav, 1)

      this.webservice.getEmpresa(empresafav).then((result) => {
        this.setState({ empresa: result })
        this.toggleRowEmpresa(result)
        this.webservice.setCookie('central-id', parseInt(result.central, 10), 1)
      })
    }
    this.webservice.getEmpresas().then((result) => {
      this.setState({ dataEmpresas: result })
    })

    this.webservice.getCentrais().then((result) => {
      this.setState({ dataCentrais: result })
      console.log('MINHAS CENTRAIS AQUI', result)
      let central = this.webservice.getCookie('central-id')
      if (!central) {
        this.toggleRow(result[0])
      } else {
        result.map((c, i) => {
          if (c.id === parseInt(central, 10)) {
            this.setState({ selected: c })
            if (c.caridade && c.caridade.length > 0) {
              let caridades = JSON.parse(JSON.stringify(c.caridade))
              caridades.push({ id: 0, nome: 'Nenhuma no momento!' })
              this.setState({ caridades: caridades })
            }
          }
          return null
        })
      }
    })

    await this.webservice.getUserById(data.id).then((result) => {
      data.user = result
    })

    await this.webservice.getFuncById(data.id).then(async (result) => {
      if (result.length > 0) {
        this.setState({
          perfil: result[0].voucher_roles_descricao,
          func: result[0]
        })
        data.funcdata = result[0]
        data.func_id = result[0].id
        data.func_role = result[0].role
        data.caridadefunc = result[0].caridade
        await this.setState({ caridadefunc: result[0].caridade })
        return
      }
    })

    console.log('data data', data)
    await this.setState({
      isAuthenticated: true,
      isAuthenticating: false,
      userData: data,
      appshowNovaSenha: data.user.nova_senha ? true : false,
      userDatausernome: data.user.nome,
      userDatauseremail: data.user.email
    })
    this.verificaCaridade()
  }

  handleLogout() {
    this.webservice.eraseCookie('portal-token')
    this.webservice.eraseCookie('empresa-id')
    this.webservice.eraseCookie('central-id')
    //this.webservice.eraseCookie('empresa-preferida');
    this.setState({
      isAuthenticated: false,
      isAuthenticating: false,
      userData: [],
      appshowNovaSenha: false,
      userDatausernome: null,
      userDatauseremail: null
    })
  }

  modalHide() {
    this.setState({ showCentral: false })
  }

  modalHideEmpresa() {
    this.setState({ showEmpresa: false })
  }

  toggleUser() {
    var css = this.state.showUser === 'none' ? 'inherit' : 'none'
    this.setState({ showUser: css })
  }

  setOpen(nome) {
    let objState = this.state.openClose
    if (nome === 'Relatorios') {
      objState['relatorios'].class =
        'menu-dropdown classic-menu-dropdown  active '
    } else if (nome === 'Gestao') {
      objState['gestao'].class = 'menu-dropdown classic-menu-dropdown  active '
    } else if (nome === 'Corridas') {
      objState['corridas'].class =
        'menu-dropdown classic-menu-dropdown  active '
    } else {
      for (let object in objState) {
        if (objState[object].nome === nome) {
          objState[object].class =
            'menu-dropdown classic-menu-dropdown  active '
        } else {
          objState[object].class = 'menu-dropdown classic-menu-dropdown  '
        }
      }
    }
    this.setState({ openClose: objState })
  }

  toggleRow(central) {
    this.setState({ selected: central }, () => {
      this.webservice.setCookie('central-id', this.state.selected.id, 1)
    })
  }

  async toggleRowEmpresa(empresa) {
    // console.log('my empresa', empresa)
    this.webservice.getCentrais().then((result) => {
      result.map((c, i) => {
        if (c.id === empresa.central) {
          // console.log('central top', c)
          this.setState({ selected: c })
          if (c.caridade && c.caridade.length > 0) {
            let caridades = JSON.parse(JSON.stringify(c.caridade))
            caridades.push({ id: 0, nome: 'Nenhuma no momento!' })
            this.setState({ caridades: caridades })
          }
        }
        return null
      })
    })
    await this.setState({ empresa: empresa })
    await this.webservice.setCookie('empresa-preferida', empresa.id, 30)
    await this.webservice.setCookie('empresa-id', empresa.id, 1)
    await this.webservice.setCookie(
      'central-id',
      parseInt(empresa.central, 10),
      1
    )

    let data = this.state.userData
    await this.webservice.getFuncById(data.id).then(async (result) => {
      if (result.length > 0) {
        data.funcdata = result[0]
        data.func_id = result[0].id
        data.func_role = result[0].role
        data.caridadefunc = result[0].caridade
        await this.setState({
          perfil: result[0].voucher_roles_descricao,
          func: result[0],
          userData: data,
          caridadefunc: result[0].caridade
        })
        return
      }
    })

    this.verificaCaridade()
  }
  modalHidenovasenha() {
    this.setState({ appshowNovaSenha: false })
  }

  //! Não Entendi!
  getHexColor(colorStr) {
    var a = document.createElement('div')
    a.style.color = colorStr
    var colors = window
      .getComputedStyle(document.body.appendChild(a))
      .color.match(/\d+/g)
      .map(function (a) {
        return parseInt(a, 10)
      })
    document.body.removeChild(a)
    return colors.length >= 3
      ? '#' +
          ((1 << 24) + (colors[0] << 16) + (colors[1] << 8) + colors[2])
            .toString(16)
            .substr(1)
      : false
  }

  //! Não Entendi!
  shadeHexColor(color, percent) {
    var f = parseInt(color.slice(1), 16),
      t = percent < 0 ? 0 : 255,
      p = percent < 0 ? percent * -1 : percent,
      R = f >> 16,
      G = (f >> 8) & 0x00ff,
      B = f & 0x0000ff
    return (
      '#' +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    )
  }
  render() {
    console.log('--------->INICIO DA RENDERIZAÇÃO!')
    let root = document.documentElement

    let cor1 = (this.state.selected.id && this.state.isAuthenticated) ? this.state.selected.aplicativocor.foreground : this.state.centralcores.aplicativocor.foreground
    let cor2 = (this.state.selected.id && this.state.isAuthenticated) ? this.state.selected.aplicativocor.background : this.state.centralcores.aplicativocor.background
    let cor3 = (this.state.selected.id && this.state.isAuthenticated) ? this.state.selected.aplicativocor.terceary : this.state.centralcores.aplicativocor.terceary

    console.log('root cor', [this.state.selected.aplicativocor, this.state.centralcores.aplicativocor, {terceary: cor3, background: cor2, foreground: cor1},])



    root.style.setProperty('--cor-letra-icone-minha-conta', cor1 + 'FF')
    root.style.setProperty('--barra-menu', cor2 + 'FF')
    root.style.setProperty('--barra-menu-font', cor1 + 'FF')
    root.style.setProperty('--barra-menu-hover', cor2 + '44')
    root.style.setProperty('--barra-menu-hover-font', cor1 + 'FF')
    root.style.setProperty('--cor-letra-menu', cor1 + 'FF')
    root.style.setProperty('--cor-icone-menu', cor1 + 'FF')
    root.style.setProperty('--cor-letra-dropdown', cor1 + 'FF')
    root.style.setProperty('--barra-dropdown', cor2 + 'FF')
    root.style.setProperty('--barra-dropdown-font', cor1 + 'FF')
    root.style.setProperty('--barra-dropdown-hover', cor2 + '44')
    root.style.setProperty('--cor-icone-dropdown', cor1 + 'FF')
    root.style.setProperty('--barra-dropdown-hover-font', cor1 + 'FF')
    root.style.setProperty('--cor-letra-grafico', cor2 + 'FF')
    root.style.setProperty('--cor-icone-grafico', cor2 + 'FF')
    root.style.setProperty('--minha-conta-background', cor2 + 'FF')
    root.style.setProperty('--minha-conta-hover', cor2 + '44')
    root.style.setProperty('--nome', cor2 + 'CC')
    root.style.setProperty('--cor-empresas', cor2 + 'CC')
    root.style.setProperty('--cor-empresas', cor2 + 'CC')
    root.style.setProperty('--cor-caminho', cor2 + 'CC')
    root.style.setProperty('--background--geral', cor3 + 'FF')

    const childProps = {
      central: this.state.selected,
      centrais: this.state.dataCentrais,
      user: this.state.userData,
      func: this.state.func,
      favorito: null,
      empresaData: this.state.empresa,
      cores: this.state.selected.aplicativocor      
    };
    console.log('childProps',childProps)
    let logoportal = this.state.selected.logoportal ? this.state.selected.logoportal : 'vaide10quadradoroxo.png';
    let iconcentral = this.state.selected.appicon ? this.state.selected.appicon : null;
    let banner = this.state.empresa.banner ? this.state.empresa.banner : null;
    let typeportal = this.state.empresa.typeportal ? this.state.empresa.typeportal : 0;
    let logoportalempresa =  this.state.empresa.logoportal ? this.state.empresa.logoportal : 'logo-portal.png';
    let iconempresa = this.state.empresa.appicon ? this.state.empresa.appicon : null;
    let iconecaridade = this.state.caridadeescolhida ? this.state.caridadeescolhida.icone ? this.state.caridadeescolhida.icone : null : null;



    return (
      <Router>
        <div className='page-wrapper'>
          {this.state.isAuthenticated && (
            <div className='page-wrapper-row'>
              <div className='page-wrapper-top'>
                <div
                  className='page-header'
                  style={{ backgroundColor: '#FFFFFF00' }}
                >
                  {this.state.isAuthenticated && (
                    <div className='page-header-top'>
                      <div className='container'>
                        <div className='page-logo' style={{ width: 'auto' }}>
                          <Link to='/'>
                            {iconcentral === null && (
                              <img
                                src={require('./images/' + logoportal)}
                                alt='logo'
                                height={70}
                                className='logo-default'
                              />
                            )}
                            {iconcentral !== null && (
                              <img
                                src={iconcentral}
                                alt='logo'
                                height={70}
                                className='logo-default'
                              />
                            )}
                            {typeportal == 1 && (
                              <img
                                src={require('./images/hoteis.png')}
                                alt='logo'
                                height={70}
                                className='logo-default'
                              />
                            )}
                          </Link>
                          <Link to='/'>
                            {iconempresa === null && typeportal == 0 && (
                              <img
                                src={require('./images/' + logoportalempresa)}
                                alt='logo'
                                height={70}
                                className='logo-default'
                              />
                            )}
                            {iconempresa !== null && typeportal == 0 && (
                              <img
                                src={iconempresa}
                                alt='logo'
                                height={70}
                                className='logo-default'
                              />
                            )}
                            {banner !== null && typeportal == 1 && (
                              <img
                                src={banner}
                                alt='logo'
                                height={70}
                                className='logo-default'
                              />
                            )}
                          </Link>
                          {iconecaridade !== null && (
                            <img
                              src={iconecaridade}
                              alt='logo'
                              height={70}
                              className='logo-default'
                            />
                          )}

                          <div className='menu-toggler sidebar-toggler'></div>
                        </div>
                        <div className='top-menu'>
                          <ul className='nav navbar-nav pull-right'>
                            <li className='dropdown dropdown-user dropdown-dark'
                              style={{
                                marginTop: 10
                              }}>
                              <button
                                type='button'
                                onClick={() =>
                                  this.setState({ showEmpresa: true })
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: 'none !important',
                                    padding: 5
                                  }}
                                >
                                  <span
                                    style={{ fontSize: 11, lineHeight: 0.9 }}
                                  >
                                    <i className='fa fa-car'></i>&nbsp;
                                    {this.state.selected.id &&
                                      this.state.selected.nomefantasia}
                                  </span>
                                  <br />
                                  {/* Aqui é onde fica o nome da empresa no topo */}
                                  <span
                                    style={{ fontSize: 20, lineHeight: 0.8 }}
                                  >
                                    {this.state.empresa.razaosocial}
                                  </span>
                                </span>
                              </button>
                            </li>
                            <li
                              className='dropdown dropdown-user dropdown-dark'
                              style={{
                                marginTop: 10
                              }}
                              onClick={this.toggleUser.bind(this)}
                            >
                              <button
                                type='button'
                                style={
                                  {
                                    // border: 0,
                                    // backgroundColor:
                                    //   this.state.selected.aplicativocor.terceary
                                  }
                                }
                              >
                                <ul
                                  className='nav navbar-nav pull-right'
                                  // style={{
                                  //   backgroundColor:
                                  //     this.state.selected.aplicativocor.terceary
                                  // }}
                                >
                                  <li>
                                    <h4
                                    // style={{
                                    //   background:
                                    //     this.state.selected.aplicativocor
                                    //       .terceary
                                    // }}
                                    >
                                      {/* {console.log(
                                      'state.userData',
                                      this.state.userData
                                    )} */}
                                      {this.state.userData.nomecompleto
                                        ? this.state.userData.nomecompleto
                                        : this.state.userData.nome}
                                      <br />
                                      <small
                                      // style={{
                                      //   background:
                                      //     this.state.selected.aplicativocor
                                      //       .terceary
                                      // }}
                                      >
                                        {' '}
                                        {this.state.userData.funcdata
                                          ? this.state.userData.funcdata
                                              .voucher_roles_descricao
                                          : ''}{' '}
                                      </small>
                                    </h4>
                                  </li>
                                  <li>
                                    <i className='fa fa-angle-down'></i>
                                  </li>
                                </ul>
                              </button>
                              <ul
                                className='dropdown-menu dropdown-menu-default'
                                style={{
                                  display: this.state.showUser
                                }}
                              >
                                <li
                                  style={{
                                    color: cor1,
                                    background: cor2
                                  }}
                                >
                                  <Link to='/minha-conta'>
                                    <i className='icon-user'></i> Minha Conta{' '}
                                  </Link>
                                </li>
                                <li
                                  style={{
                                    color: cor1,
                                    background: cor2
                                  }}
                                >
                                  <Link to='/favoritos'>
                                    <i className='icon-star'></i> Endereços
                                    Salvos{' '}
                                  </Link>
                                </li>
                                <li
                                  style={{
                                    color: cor1,
                                    background: cor2
                                  }}
                                >
                                  <Link
                                    to=''
                                    onClick={() => this.modalShowcaridade()}
                                  >
                                    <i className='fa fa-heartbeat'></i> Minha
                                    Caridade{' '}
                                  </Link>
                                </li>
                                <li
                                  style={{
                                    color: cor1,
                                    background: cor2
                                  }}
                                >
                                  <Link
                                    to=''
                                    onClick={() => this.handleLogout()}
                                  >
                                    <i className='icon-key'></i> Sair
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <button
                                type='button'
                                className='link-button'
                                style={{ paddingTop: 9, paddingBottom: 1 }}
                                onClick={() =>
                                  this.setState({ showCentral: true })
                                }
                              >
                                <ul className='nav navbar-nav pull-right'>
                                  <li>
                                    <img
                                      alt=''
                                      src={require('./images/GO-Express-icone.png')}
                                      height={65}
                                    />
                                  </li>
                                </ul>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                )}
                <div className="page-header-menu" style={{ display: 'block' }}>
                  <div className="container">
                    {this.state.isAuthenticated && (
                      <div className="hor-menu">
                        <ul className="nav navbar-nav">
                          {(this.state.perfil === "Gestor" ||
                            this.state.perfil === "Administrador") &&
                            <li className={this.state.openClose.painel.class} onClick={e => this.setOpen(this.state.openClose.painel.nome)}>
                              <Link to="/painel" className="nav-link">
                                <i className="icon-home"></i>&nbsp;
                              <span className="title">Painel</span>
                                <span className="selected"></span>
                                <span className="arrow"></span>
                              </Link>
                            </li>
                          }
                          {(this.state.perfil === "Gestor" ||
                            this.state.perfil === "Administrador" ||
                            this.state.perfil === "Autorizado" ||
                            this.state.perfil === "Usuário Solicitante" ||
                            this.state.perfil === "Usuário" ||
                            this.state.perfil === "Sub-Gestor" ||
                            this.state.perfil === "Solicitante" ||
                            this.state.perfil === "Contas a Pagar") &&
                            <li className={this.state.openClose.solicitarCorrida.class}>
                              <Link to="/solicitar" className="nav-link">
                                <i className="icon-pointer"></i>&nbsp;
                              <span className="title">Nova Solicitação</span>
                                <span className="selected"></span>
                              </Link>
                            </li>
                          }
                            
                            {(this.state.perfil === 'Gestor' ||
                              this.state.perfil === 'Administrador' ||
                              this.state.perfil === 'Autorizado' ||
                              this.state.perfil === 'Usuário Solicitante' ||
                              this.state.perfil === 'Usuário' ||
                              this.state.perfil === 'Sub-Gestor' ||
                              this.state.perfil === 'Solicitante' ||
                              this.state.perfil === 'Contas a Pagar') && (
                              <li
                                className={this.state.openClose.corridas.class}
                                onClick={(e) =>
                                  this.setOpen(
                                    this.state.openClose.corridas.nome
                                  )
                                }
                              >
                                <Link to='/' className=' nav-link'>
                                  <i className='fa fa-taxi'></i>&nbsp;
                                  <span className='title'>
                                  Solicitações
                                  </span>
                                  <span className='selected'></span>
                                  <span className='arrow'></span>
                                </Link>
                                <ul className='dropdown-menu pull-left'>
                                  <li
                                    className={
                                      this.state.openClose.corridasAndamento
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.corridasAndamento
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/corrida-andamento'
                                      className=' nav-link'
                                    >
                                      <i className='icon-paper-plane'></i>&nbsp;
                                      <span className='title'>
                                        Em Andamento
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={
                                      this.state.openClose.corridasAgendadas
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.corridasAgendadas
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/corridas-agendadas'
                                      className=' nav-link'
                                    >
                                      <i className='icon-clock'></i>&nbsp;
                                      <span className='title'>Agendadas</span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={
                                      this.state.openClose.corridasConcluidas
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.corridasConcluidas
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/corridas-concluidas'
                                      className=' nav-link'
                                    >
                                      <i className='icon-tag'></i>&nbsp;
                                      <span className='title'>Concluídas</span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={
                                      this.state.openClose.corridasCanceladas
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.corridasCanceladas
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/corridas-canceladas'
                                      className=' nav-link'
                                    >
                                      <i className='icon-ban'></i>&nbsp;
                                      <span className='title'>Canceladas</span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                </ul>
                              </li>
                            )}
                            {(this.state.perfil === 'Gestor' ||
                              this.state.perfil === 'Administrador' ||
                              this.state.perfil === 'Contas a Pagar') && (
                              <li
                                className={this.state.openClose.faturas.class}
                                onClick={(e) =>
                                  this.setOpen(
                                    this.state.openClose.faturas.nome
                                  )
                                }
                              >
                                <Link to='/faturas' className='nav-link'>
                                  <i className='icon-credit-card'></i>&nbsp;
                                  <span className='title'>Faturas</span>
                                  <span className='selected'></span>
                                  <span className='arrow'></span>
                                </Link>
                              </li>
                            )}
                            {(this.state.perfil === 'Gestor' ||
                              this.state.perfil === 'Administrador' ||
                              this.state.perfil === 'Solicitante') && (
                              <li
                                className={this.state.openClose.gestao.class}
                                onClick={(e) =>
                                  this.setOpen(this.state.openClose.gestao.nome)
                                }
                              >
                                <Link
                                  to='/corridas-agendadas'
                                  className=' nav-link'
                                >
                                  <i className='icon-settings'></i>&nbsp;
                                  <span className='title'>Gestão</span>
                                  <span className='selected'></span>
                                  <span className='arrow'></span>
                                </Link>
                                <ul className='dropdown-menu pull-left'>
                                  <li
                                    className={
                                      this.state.openClose.cadastroAutorizados
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.cadastroAutorizados
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/cadastro-autorizados'
                                      className='nav-link'
                                    >
                                      <i className='icon-users'></i>&nbsp;
                                      <span className='title'>Autorizados</span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  {false && (
                                    <li
                                      className={
                                        this.state.openClose.voucherAvulso.class
                                      }
                                      onClick={(e) =>
                                        this.setOpen(
                                          this.state.openClose.voucherAvulso
                                            .nome
                                        )
                                      }
                                    >
                                      <Link
                                        to='voucher-avulso'
                                        className='nav-link'
                                      >
                                        <i className='icon-bulb'></i>&nbsp;
                                        <span className='title'>
                                          Vouchers Avulso
                                        </span>
                                        <span className='selected'></span>
                                      </Link>
                                    </li>
                                  )}
                                  <li
                                    className={
                                      this.state.openClose.cadastroDepartamento
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose
                                          .cadastroDepartamento.nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='cadastro-departamento'
                                      className='nav-link'
                                    >
                                      <i className='icon-briefcase'></i>&nbsp;
                                      <span className='title'>
                                        Departamentos
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                </ul>
                              </li>
                            )}
                            {(this.state.perfil === 'Gestor' ||
                              this.state.perfil === 'Administrador' ||
                              this.state.perfil === 'Sub-Gestor' ||
                              this.state.perfil === 'Contas a Pagar') && (
                              <li
                                className={
                                  this.state.openClose.relatorios.class
                                }
                                onClick={(e) =>
                                  this.setOpen(
                                    this.state.openClose.relatorios.nome
                                  )
                                }
                              >
                                <Link
                                  to='/corridas-agendadas'
                                  className=' nav-link'
                                >
                                  <i className='icon-bar-chart'></i>&nbsp;
                                  <span className='title'>Relatórios</span>
                                  <span className='selected'></span>
                                  <span className='arrow'></span>
                                </Link>
                                <ul className='dropdown-menu pull-left'>
                                  <li
                                    className={
                                      this.state.openClose.vouchersAFaturar
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.vouchersAFaturar
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/voucher-faturar'
                                      className='nav-link'
                                    >
                                      <i className='icon-home'></i>&nbsp;
                                      <span className='title'>
                                        Vouchers à Faturar
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={
                                      this.state.openClose.vouchersFaturados
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.vouchersFaturados
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/voucher-faturados'
                                      className='nav-link'
                                    >
                                      <i className='icon-bulb'></i>&nbsp;
                                      <span className='title'>
                                        Vouchers Faturados
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={
                                      this.state.openClose.vouchersCancelados
                                        .class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.vouchersCancelados
                                          .nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/voucher-cancelados'
                                      className='nav-link'
                                    >
                                      <i className='icon-bulb'></i>&nbsp;
                                      <span className='title'>
                                        Vouchers Cancelados
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  {/*<li className={this.state.openClose.vouchersNaoAutorizado.class} onClick={e => this.setOpen(this.state.openClose.vouchersNaoAutorizado.nome)}>
                                  <Link to="/voucher-nao-auth" className="nav-link">
                                    <i className="icon-bulb"></i>&nbsp;
                                  <span className="title">Vouchers Não Autorizados</span>
                                    <span className="selected"></span>
                                  </Link>
                                  </li>*/}
                                  <li
                                    className={
                                      this.state.openClose.empregados.class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.empregados.nome
                                      )
                                    }
                                  >
                                    <Link to='/empregados' className='nav-link'>
                                      <i className='icon-bulb'></i>&nbsp;
                                      <span className='title'>
                                        Funcionarios
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                  <li
                                    className={
                                      this.state.openClose.centroDeCusto.class
                                    }
                                    onClick={(e) =>
                                      this.setOpen(
                                        this.state.openClose.centroDeCusto.nome
                                      )
                                    }
                                  >
                                    <Link
                                      to='/centro-de-custo'
                                      className='nav-link'
                                    >
                                      <i className='icon-bulb'></i>&nbsp;
                                      <span className='title'>
                                        Centro de custo
                                      </span>
                                      <span className='selected'></span>
                                    </Link>
                                  </li>
                                </ul>
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className='page-wrapper-row full-height'>
            <div className='page-wrapper-middle'>
              <div className='page-container'>
                <Modal
                  keyboard
                  show={this.state.showCentral}
                  onHide={this.modalHide}
                  container={this}
                  aria-labelledby='contained-modal-title'
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <i className='fa fa-star-o'></i>&nbsp; CONTADO
                      DESENVOLVEDOR
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className='portlet-body'>
                      <div>
                        <div className='well'>
                          <address>
                            <strong>GO Express</strong>
                            <br />
                            Sistemas de Gestão e Apps para empresas de Entregas
                            e Transportes
                            <br />
                            Rua Álvaro Andrade, 435
                            <br />
                            Bairro Portão, Curitiba, 80610240
                            <br />
                            <abbr title='Phone'>Tel:</abbr> (41) 3288-7149
                            <br />
                            <strong>Email </strong>
                            <a
                              target='_blank'
                              href='mailto:comercial@goapps.com.br'
                            >
                              comercial@goapps.com.br
                            </a>
                            <br />
                            <strong>Email </strong>
                            <a
                              target='_blank'
                              href='mailto:suporte@goapps.com.br'
                            >
                              suporte@goapps.com.br
                            </a>
                            <br />
                            <strong>Site </strong>
                            <a target='_blank' href='http://www.goapps.com.br'>
                              www.goapps.com.br
                            </a>
                            <br />
                            <strong>Facebook </strong>
                            <a
                              target='_blank'
                              href='http://www.facebook.com/solucoesgoexpress'
                            >
                              @solucoesgoexpress
                            </a>
                            <br />
                            <strong>Instagram </strong>
                            <a
                              target='_blank'
                              href='http://www.instagram.com/solucoesgoexpress'
                            >
                              @solucoesgoexpress
                            </a>
                            <br />
                          </address>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      onClick={() => this.modalHide()}
                      className='link-button btn default'
                    >
                      Fechar
                    </button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  keyboard
                  show={this.state.appshowNovaSenha}
                  onHide={this.modalHidenovasenha}
                  container={this}
                  aria-labelledby='contained-modal-title'
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Mudar Senha</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className='form-horizontal'>
                      <div className={'alert ' + this.state.alertDisplay}>
                        <button
                          className='link-button close'
                          onClick={() =>
                            this.setState({ alertDisplay: 'display-hide' })
                          }
                        ></button>
                        <span>{this.state.alertText}</span>
                      </div>
                      <div className='form-body'>
                        <div className='form-group form-md-line-input'>
                          <label className='col-md-3 control-label'>
                            Nova Senha
                          </label>
                          <div className='col-md-9'>
                            <div className='input-icon left'>
                              <input
                                className='form-control'
                                value={this.state.senha}
                                type='password'
                                onChange={(e) =>
                                  this.setState({ senha: e.target.value })
                                }
                              />
                              <div className='form-control-focus'></div>
                            </div>
                          </div>
                        </div>
                        <div className='form-group form-md-line-input'>
                          <label className='col-md-3 control-label'>
                            Confirmar Senha
                          </label>
                          <div className='col-md-9'>
                            <div className='input-icon left'>
                              <input
                                className='form-control'
                                value={this.state.senhaConfirm}
                                type='password'
                                onChange={(e) =>
                                  this.setState({
                                    senhaConfirm: e.target.value
                                  })
                                }
                              />
                              <div className='form-control-focus'></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div>
                      <button
                        className='link-button btn blue'
                        onClick={() => {
                          if (
                            this.state.senhaConfirm !== '' &&
                            this.state.senha !== ''
                          ) {
                            if (this.state.senhaConfirm === this.state.senha) {
                              this.webservice
                                .editSenhaUser(
                                  this.state.senha,
                                  this.state.userData.id
                                )
                                .then(() => {
                                  this.modalHidenovasenha()
                                  alert('Senha alterada com sucesso!')
                                })
                            } else {
                              this.setState({
                                alertDisplay: 'alert-danger',
                                alertText: 'As senhas não conferem!'
                              })
                            }
                          } else {
                            this.setState({
                              alertDisplay: 'alert-danger',
                              alertText: 'Por favor preencha sua nova senha!'
                            })
                          }
                        }}
                      >
                        Salvar
                      </button>
                      &nbsp;
                      <button
                        className='link-button btn default'
                        onClick={() => this.modalHidenovasenha()}
                      >
                        Fechar
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>
                <Modal
                  keyboard
                  show={this.state.showcaridade}
                  onHide={this.modalhidecaridae}
                  container={this}
                  aria-labelledby='contained-modal-title'
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <i className='fa fa-heartbeat'></i>&nbsp; Apoie a Caridade
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div>
                      {this.state.caridades.map((a, b) => {
                        console.log('this.state.caridadefunc === a.id', [
                          this.state.caridadefunc,
                          a.id
                        ])
                        let cor =
                          this.state.caridadefunc === a.id
                            ? '#BF0426'
                            : '#6d3a8e'
                        return (
                          <div
                            onClick={() => this.SetaCaridades(a.id)}
                            className='caridade'
                            style={{
                              alignContent: 'center',
                              alignItems: 'center',
                              justifyContent: 'center',
                              display: 'inline-block',
                              padding: 5,
                              margin: 5,
                              borderColor: cor,
                              borderStyle: 'solid'
                            }}
                          >
                            {a.icone && (
                              <img
                                src={a.icone}
                                alt='logo'
                                height={150}
                                className='logo-default'
                              />
                            )}
                            {!a.icone && (
                              <img
                                src={require('./images/logo-portal.png')}
                                alt='logo'
                                height={150}
                                className='logo-default'
                              />
                            )}

                            <p
                              style={{
                                fontSize: 15,
                                fontWeight: 'bold',
                                textAlign: 'center'
                              }}
                            >
                              {a.nome}
                            </p>
                          </div>
                        )
                      })}
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal
                  keyboard
                  show={this.state.showEmpresa}
                  onHide={this.modalHideEmpresa}
                  container={this}
                  aria-labelledby='contained-modal-title'
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <i className='fa fa-star-o'></i>&nbsp; Informações do
                      Convênio
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className='portlet-body'>
                      <div>
                        <div className='well'>
                          <address>
                            <strong>
                              Prestador de Serviço:{' '}
                              {this.state.selected.id &&
                                this.state.selected.nomefantasia}
                            </strong>
                            <br />
                            {!!this.state.selected.endereco && (
                              <>
                                {this.state.selected.id &&
                                  this.state.selected.endereco.rua +
                                    ', ' +
                                    this.state.selected.endereco.numero}
                                <br />
                                {this.state.selected.id &&
                                  this.state.selected.endereco.cidade}
                                ,{' '}
                                {this.state.selected.id &&
                                  this.state.selected.endereco.cep}
                                <br />
                                <abbr title='Phone'>Tel:</abbr>{' '}
                                {this.state.selected.id &&
                                  this.state.selected.endereco.telefonecontato}
                                <br />
                                <abbr title='Phone'>Tel:</abbr>{' '}
                                {this.state.selected.id &&
                                  this.state.selected.endereco.celularcontato}
                                <br />
                                <strong>Email: </strong>
                                <a
                                  href={
                                    this.state.selected.id &&
                                    'mailto:' +
                                      this.state.selected.endereco.email
                                  }
                                >
                                  {this.state.selected.id &&
                                    this.state.selected.endereco.email}
                                </a>
                                <br />
                                <strong>Site: </strong>
                                <a
                                  target='_blank'
                                  href={
                                    this.state.selected.id &&
                                    this.state.selected.endereco.site
                                  }
                                >
                                  {this.state.selected.id &&
                                    this.state.selected.endereco.site}
                                </a>
                                <br />
                              </>
                            )}
                          </address>
                        </div>
                        <div className='well'>
                          <address>
                            <strong>
                              Conveniado:{' '}
                              {this.state.empresa &&
                                this.state.empresa.razaosocial}
                            </strong>
                            <br />
                            {this.state.empresa && this.state.empresa.cnpj}
                            <br />
                            {this.state.empresa && this.state.empresa.endereco}
                            <br />
                            <abbr title='Phone'>Tel:</abbr>{' '}
                            {this.state.selected.id &&
                              this.state.empresa.telefone}
                          </address>
                        </div>
                      </div>
                      {this.state.dataEmpresas &&
                        this.state.dataEmpresas.length > 1 && (
                          <div className='well'>
                            <address>
                              <strong>Outros Convênios do Associado</strong>
                              <br />
                            </address>
                            <ReactTable
                              data={this.state.dataEmpresas}
                              previousText='Anterior'
                              nextText='Próxima'
                              loadingText='Carregando...'
                              noDataText='Nenhum dado encontrado'
                              pageText='Página'
                              ofText='de'
                              rowsText='linhas'
                              pageSize={
                                this.state.dataEmpresas.length !== 0
                                  ? this.state.dataEmpresas.length
                                  : 4
                              }
                              columns={[
                                {
                                  Header: (
                                    <div className='header-table-left'>
                                      <i className='fa fa-taxi'></i>
                                      &nbsp;Empresa
                                    </div>
                                  ),
                                  accessor: 'razaosocial'
                                },
                                {
                                  id: 'checkbox',
                                  accessor: '',
                                  Cell: ({ original }) => {
                                    return (
                                      <input
                                        type='checkbox'
                                        className='checkbox'
                                        checked={
                                          this.state.empresa.razaosocial ===
                                          original.razaosocial
                                            ? true
                                            : false
                                        }
                                        onChange={() =>
                                          this.toggleRowEmpresa(original)
                                        }
                                      />
                                    )
                                  },
                                  Header: (
                                    <div className='header-table-left'>
                                      <i className='fa fa-pencil-square-o'></i>
                                      &nbsp;Padrão
                                    </div>
                                  )
                                }
                              ]}
                              defaultPageSize={this.state.dataEmpresas.length}
                              showPagination={false}
                              className='-striped -highlight'
                            />
                          </div>
                        )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      onClick={() => this.modalHideEmpresa()}
                      className='link-button btn default'
                    >
                      Fechar
                    </button>
                  </Modal.Footer>
                </Modal>

                {this.state.isAuthenticated ? (
                  <Switch>
                    <Route
                      exact
                      path='/'
                      render={(props) => {
                        if (this.state.selected) {
                          if (this.state.selected.transporte) {
                            return (
                              <Solicitar {...props} childProps={childProps} />
                            )
                          } else if (this.state.selected.encomendas) {
                            return (
                              <Solicitar {...props} childProps={childProps} />
                            )
                          } else {
                            return (
                              <Solicitar {...props} childProps={childProps} />
                            )
                          }
                        } else {
                          return (
                            <Solicitar {...props} childProps={childProps} />
                          )
                        }
                      }}
                    />
                    <Route
                      exact
                      path='/painel'
                      render={(props) => (
                        <Painel {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/minha-conta'
                      render={(props) => (
                        <MinhaConta {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/solicitar-corrida'
                      render={(props) => (
                        <Solicitar {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/solicitar'
                      render={(props) => (
                        <Solicitar {...props} childProps={childProps} />
                      )}
                    />
                    {this.state.selected.transporte && (
                      <Route
                        exact
                        path='/pedir-taxi'
                        render={(props) => (
                          <Solicitar {...props} childProps={childProps} />
                        )}
                      />
                    )}
                    {this.state.selected.encomendas && (
                      <Route
                        exact
                        path='/pedir-enc'
                        render={(props) => (
                          <Solicitar {...props} childProps={childProps} />
                        )}
                      />
                    )}
                    <Route
                      exact
                      path='/corrida-registrada'
                      render={(props) => (
                        <CorridaRegistrada {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/corrida-andamento'
                      render={(props) => (
                        <CorridasAndamento {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/corridas-agendadas'
                      render={(props) => (
                        <CorridasAgendadas {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/corridas-concluidas'
                      render={(props) => (
                        <CorridasConcluidas
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/corridas-canceladas'
                      render={(props) => (
                        <CorridasCanceladas
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/detalhes-corrida'
                      render={(props) => (
                        <DetalhesCorrida {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/faturas'
                      render={(props) => (
                        <Faturas {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/cadastro-autorizados'
                      render={(props) => (
                        <CadastroAutorizados
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/novo-autorizado'
                      render={(props) => (
                        <NovoAutorizado {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/editar-autorizado'
                      render={(props) => (
                        <EditarAutorizado {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/voucher-avulso'
                      render={(props) => (
                        <VoucherAvulso {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/cadastro-departamento'
                      render={(props) => (
                        <CadastroDepartamento
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/novo-departamento'
                      render={(props) => (
                        <NovoDepartamento {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/novo-voucher-avulso'
                      render={(props) => (
                        <NovoVoucherAvulso {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/editar-voucher-avulso'
                      render={(props) => (
                        <EditarVoucherAvulso
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/voucher-faturar'
                      render={(props) => (
                        <VouchersAFaturar {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/voucher-faturados'
                      render={(props) => (
                        <VouchersFaturados {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/voucher-cancelados'
                      render={(props) => (
                        <VouchersCancelados
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/voucher-nao-auth'
                      render={(props) => (
                        <VouchersNaoAutorizados
                          {...props}
                          childProps={childProps}
                        />
                      )}
                    />
                    <Route
                      exact
                      path='/empregados'
                      render={(props) => (
                        <Empregados {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      exact
                      path='/centro-de-custo'
                      render={(props) => (
                        <CentroDeCusto {...props} childProps={childProps} />
                      )}
                    />
                    {/* <Route exact path="/voucher-contestados" render={(props) => (
                      <VouchersContestados {...props} childProps={childProps} />
                    )} /> */}
                    <Route
                      exact
                      path='/rede-credenciada'
                      render={(props) => (
                        <RedeCredenciada {...props} childProps={childProps} />
                      )}
                    />
                    <Route
                      path='/favoritos'
                      render={(props) => (
                        <MeusFavoritos {...props} childProps={childProps} />
                      )}
                    />
                  </Switch>
                ) : (
                  <Switch>
                    <Route exact path="/t/:id" render={(props) => (
                      <Acompanhamento {...props} childProps={childProps} />
                    )} />
                    <Route exact path="/reset_password/:id" render={(props) => (
                      <ResetSenha {...props} childProps={childProps} />
                    )} />
                    <Route exact path="/cadastro" render={(props) => (
                      <Precadastro {...props} icone={this.state.centralcores.appicon} childProps={childProps} central={this.state.centralcores.id}  />
                    )} />
                    <Route exact path="/cadastro/:id" render={(props) => (
                      <Precadastro {...props} icone={this.state.centralcores.appicon} childProps={childProps} central={this.state.centralcores.id}  />
                    )} />
                    
                    <Route exact path="*" render={(props) => (
                      <Login {...props} icone={this.state.centralcores.appicon} central={this.state.centralcores.id} childProps={childProps} loginUser={this.loginUser} />
                    )} />


                  </Switch>
                )}
              </div>
            </div>
          </div>
        </div>
      </Router>
    )
  }
}

export default AppOld